import { render, staticRenderFns } from "./TheDashboard.vue?vue&type=template&id=2de7fad1&scoped=true"
import script from "./TheDashboard.vue?vue&type=script&lang=js"
export * from "./TheDashboard.vue?vue&type=script&lang=js"
import style0 from "./TheDashboard.vue?vue&type=style&index=0&id=2de7fad1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de7fad1",
  null
  
)

export default component.exports